
<template>

    <div class="InputQuery">

  
        <input type="text"
               ref="Element"
               v-model="m_Text"
               :class="CssClass"
               autocomplete="off"
               :disabled="disabled"
               :placeholder="m_PlaceHolder"
               :nullable="m_Nullable"
               :title="m_title"
               @change="OnInputChange"
               @blur="OnBlur"
               @click="OnClick"
               @keydown.33="OnPageUp"
               @keydown.34="OnPageDwon"
               @keydown.enter="OnEnter"
               @keydown.up="OnMoveUp"
               @keydown.down="OnMoveDown"
               @keyup="OnKeyUp" />

        <div v-if="IsQuery" class="LoadingBlock">
            Loading ...
        </div>
        <div class="DropDownMenu" ref="DropDownMenu" v-show="FinalOptions.length>0">
            <div v-for="(option ,index) in FinalOptions" class="OptionItem"
                 :class="{Selected:(SelectedIndex==index||(m_Value==option.Value&&Strict=='true') ),
                   NotSelectable:option.Selectable==false
                 }"
                 @click="OnOptionItemClick(option,index)"
                 v-html="option.Text">
            </div>
        </div>


    </div>


</template>

<script scoped>
    import apiService from '@/Common/ApiService'
    import Utility from '@/Common/Utility'


    export default {
        name: "t-inputquery",
        data() {
            return {
                lastKeyUpTime: new Date(),
                lastQueryTime: new Date(),
                lastKeyWord: "",
                IsQuery: false,
                apiUrl: "/api/Customer/List",
                FinalOptions: [],
                SelectedIndex: 0,

                m_RequestQueryNo: 0,
                m_LstRequestQueryNo: -1,
                m_PlaceHolder:"",
                m_Value: "",
                m_Nullable:true,
                m_LastText:"@" ,
                m_Text: "",
                m_LastOptionText: "",
                m_LastOptionCount: 0,
                m_title: "",
                m_LastEmitTime: Date.parse("1990/1/1"),
                m_ValueData: {},

                cacheResponseRows : [],

                m_Attribute: {
                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false
                }
            }
        }
        ,
        props: [
            "value",
            "title",
            "disabled",
            "nullable",
            "Strict" ,
            "Attribute",
            "PlaceHolder" ,
            "QueryApiUrl",
            "ShowAllOptions",
            "GetOptionSelectableHandler" ,
            "CreateInputTextHandler",
            "CreateOptionTextHandler",
            "CreateQueryRequestHandler",
            "IsNewGetDataVersion",
            "ClearAfterChange",
            "GetData",
            "GetData2",
            "GetDataIsList"
        ],


        computed: {

            Disabled: function () {
                let result = false;

                if (this.Attribute != null && this.Attribute.Enabled != null) {
                    result = !this.Attribute.Enabled;
                }

                return result;
            }
            ,
            CssClass: function () {
                let result = "";


                if (this.Attribute != null && this.Attribute.CssClass != null) {
                    result = this.Attribute.CssClass;
                }

                return result;
            }
            ,



        }
        ,

        methods: {

            OnInputChange() {
                 if (this.m_Text == "") {
                      
                    this.$emit("change",
                        this.m_Text,
                        null,
                        null,
                        this
                    );
                }
            },

            Focus() {
                this.$refs.Element.focus();
            },

            OnMoveDown(e) {
                let selectedElement;
                let dropDownMenuScrollTop = 0;

                if (this.SelectedIndex < this.FinalOptions.length - 1) {
                    this.SelectedIndex++;

                    selectedElement = this.$refs.DropDownMenu.querySelector(".OptionItem.Selected");
                    dropDownMenuScrollTop = this.$refs.DropDownMenu.scrollTop;

                    if (selectedElement != null) {
                        if (
                            selectedElement.offsetTop + 50 >
                            (dropDownMenuScrollTop + this.$refs.DropDownMenu.clientHeight)
                        ) {
                            this.$refs.DropDownMenu.scrollTop =
                                (selectedElement.offsetTop + 50) -
                                this.$refs.DropDownMenu.clientHeight;
                        }
                    }
                }
                e.preventDefault();
            },

            OnMoveUp() {
                let selectedElement;
                let dropDownMenuScrollTop = 0;

                if (this.SelectedIndex > 0) {
                    this.SelectedIndex--;

                    selectedElement = this.$refs.DropDownMenu.querySelector(".OptionItem.Selected");
                    dropDownMenuScrollTop = this.$refs.DropDownMenu.scrollTop;


                    if (selectedElement.offsetTop - 20 < dropDownMenuScrollTop) {
                        this.$refs.DropDownMenu.scrollTop = selectedElement.offsetTop - 20;
                    }
                }
            },


            OnPageUp(e) {

                let newSelectedIndex;
                let selectedElement;
                let dropDownMenuScrollTop = 0;
                let recordPerPage = 1;

                if (this.$refs.DropDownMenu.children.length > 0) {
                    recordPerPage = Math.floor(this.$refs.DropDownMenu.clientHeight / this.$refs.DropDownMenu.children[0].clientHeight);
                }
                else {
                    return;

                }

                if (this.SelectedIndex - recordPerPage > 0) {
                    this.SelectedIndex -= recordPerPage;

                }
                else {

                    this.SelectedIndex = 0;
                }

                e.preventDefault();
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();


                setTimeout(
                    () => {
                        selectedElement = this.$refs.DropDownMenu.querySelector(".OptionItem.Selected");
                        dropDownMenuScrollTop = this.$refs.DropDownMenu.scrollTop;

                        if (selectedElement.offsetTop < this.$refs.DropDownMenu.clientHeight) {
                            this.$refs.DropDownMenu.scrollTop = selectedElement.offsetTop;
                        }
                    }
                    ,
                    10
                );


                return false;
            },


            OnPageDwon(e) {
                let newSelectedIndex;
                let selectedElement;
                let dropDownMenuScrollTop = 0;
                let recordPerPage = 1;

                if (this.$refs.DropDownMenu.children.length > 0) {
                    recordPerPage = Math.floor(this.$refs.DropDownMenu.clientHeight / this.$refs.DropDownMenu.children[0].clientHeight);
                }
                else {
                    return;

                }

                if (this.SelectedIndex + recordPerPage < this.FinalOptions.length) {
                    this.SelectedIndex += recordPerPage;

                }
                else {
                    this.SelectedIndex = this.FinalOptions.length - 1;
                }

                e.preventDefault();
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();


                setTimeout(
                    () => {
                        selectedElement = this.$refs.DropDownMenu.querySelector(".OptionItem.Selected");
                        dropDownMenuScrollTop = this.$refs.DropDownMenu.scrollTop;

                        if (
                            selectedElement.offsetTop + 50 >
                            (dropDownMenuScrollTop + this.$refs.DropDownMenu.clientHeight)
                        ) {
                            this.$refs.DropDownMenu.scrollTop =
                                (selectedElement.offsetTop + 50) -
                                this.$refs.DropDownMenu.clientHeight;
                        }

                    },
                    10
                );


                return false;
            },

            SetSelectedOptionItemVisible() {
                let selectedElement;
                let dropDownMenuScrollTop = 0;
                let recordPerPage = 1;

                selectedElement = this.$refs.DropDownMenu.querySelector(".OptionItem.Selected");
                dropDownMenuScrollTop = this.$refs.DropDownMenu.scrollTop;

                if (
                    selectedElement.offsetTop + 50 >
                    (dropDownMenuScrollTop + this.$refs.DropDownMenu.clientHeight)
                ) {
                    this.$refs.DropDownMenu.scrollTop =
                        (selectedElement.offsetTop + 50) -
                        this.$refs.DropDownMenu.clientHeight;
                }
                else if (selectedElement.offsetTop < this.$refs.DropDownMenu.clientHeight) {
                    this.$refs.DropDownMenu.scrollTop = selectedElement.offsetTop;
                }
            },


            OnOptionItemClick(option, index) {
                let row = null;


                this.hasTrigger = true;

                console.log("OnOptionItemClick")
                if (option.Selectable == false) {
                    return;
                }

                this.SelectedIndex = index;


                if (
                    this.SelectedIndex >= 0 &&
                    this.SelectedIndex < this.FinalOptions.length &&
                    this.FinalOptions.length >= 0
                ) {
                    if (this.FinalOptions[this.SelectedIndex] == null) {
                        debugger;
                    }
                    try {
                        row = this.FinalOptions[this.SelectedIndex].Row;
                    }
                    catch (e) {
                        debugger;
                    }
                }
                if (this.GetData2 != undefined && this.GetData2 != null && this.GetData2 != "") {
                    this.$emit("change", this.m_Text, row, this.GetData, this.GetData2, this);
                }
                else {
                    this.$emit("change", this.m_Text, row, this.GetData, this);
                }


                if (this.CreateInputTextHandler != null) {
                    this.m_Text = this.CreateInputTextHandler(this.m_Text, row);
                }

                if (this.ClearAfterChange == "true" || this.ClearAfterChange == true) {
                    this.m_Text = "";
                    this.$forceUpdate();
                }

                setTimeout(
                    () => {
                        this.hasTrigger = false;
                    },
                    1000
                );

                this.SelectedIndex = -1;
                this.FinalOptions = [];
            },

            OnEnter() {
                let row = null
                let hasTrigger = false;


                if (
                    this.SelectedIndex >= 0 &&
                    this.SelectedIndex < this.FinalOptions.length) {
                    row = this.FinalOptions[this.SelectedIndex].Row;

                    hasTrigger = true;

                    this.$emit("change",
                        this.m_Text,
                        row,
                        null,
                        this
                    );

                    if (this.ClearAfterChange == "true" || this.ClearAfterChange == true) {
                        this.m_Text = "";
                        this.$forceUpdate();
                    }
                }


                this.SelectedIndex = -1;
                this.FinalOptions = [];

                if (!hasTrigger) {

                    this.$emit("change",
                        this.m_Text,
                        row,
                        null,
                        this
                    );

                    if (this.ClearAfterChange == "true" || this.ClearAfterChange == true) {
                        this.m_Text = "";
                        this.$forceUpdate();
                    }
                }
                if (this.CreateInputTextHandler != null && row != null) {
                    this.m_Text = this.CreateInputTextHandler(this.m_Text,row);
                }
                 
                if (this.ClearAfterChange == "true" || this.ClearAfterChange == true) {
                    this.m_Text = "";
                    this.$forceUpdate();
                }


                this.$refs.Element.focus();
            },


            OnBlur() {
                let row = null;

                setTimeout(
                    () => {

                       
                        if (this.hasTrigger) {
                            return;
                        }

                        console.log("OnBlur");

                        if (this.Strict == "true" || this.Strict == true) {
                            if (this.SelectedIndex >= 0
                                &&
                                this.SelectedIndex < this.FinalOptions.length
                            ) {
                                row = this.FinalOptions[this.SelectedIndex].Row;


                                this.m_Text = this.m_Text.trim();


                                this.$emit("change",
                                    this.m_Text,
                                    row,
                                    null,
                                    this
                                );

                                if (this.ClearAfterChange == "true" || this.ClearAfterChange == true) {
                                    this.m_Text = "";
                                    this.$forceUpdate();
                                }
                            }
                            else {

                                this.$emit("blur",
                                    this.m_Text,
                                    null,
                                    null,
                                    this
                                );
                            }
                        }
                        else {

                            if (this.SelectedIndex >= 0
                                &&
                                this.SelectedIndex < this.FinalOptions.length
                            ) {
                                row = this.FinalOptions[this.SelectedIndex].Row;
                            }

                            this.m_Text = this.m_Text.trim();

                            this.$emit("blur",
                                this.m_Text,
                                row,
                                null,
                                this
                            );

                        }
                    },
                    100
                );

            },

            OnClick(e) {

                if (!this.IsQuery) {
                    if (this.cacheResponseRows.length > 0) {
                        let i;

                        for (i = 0; i < this.cacheResponseRows.length; i++) {
                            let optionItem;

                            optionItem = {};
                            optionItem.Selectable = true;

                            if (this.GetOptionSelectableHandler != null) {
                                if (!this.GetOptionSelectableHandler(this.cacheResponseRows[i])) {
                                    optionItem.Selectable = false;
                                }
                            }

                            optionItem.Text = this.CreateOptionTextHandler(this.cacheResponseRows[i]);
                            optionItem.Value = optionItem.Text;
                            optionItem.Row = this.cacheResponseRows[i];

                            this.FinalOptions.push(
                                optionItem
                            );
                        }


                        this.$forceUpdate();


                        return;
                    }

                    //if (this.m_LastText != this.m_Text)
                    {
                        this.IsQuery = true;
                        this.m_LastText = this.m_Text;
                         

                        setTimeout
                            (
                                function () {
                                    this.Query();
                                    this.IsQuery = false;
                                }.bind(this)
                                ,
                                300
                            );
                    }
                }

                this.$refs.Element.focus();

            },

            OnKeyUp(e) {
                let keyword;
                let i;


                if (e.keyCode == 40 && this.SelectedIndex >= 0) {
                    return;
                }

                if (
                    e.keyCode == 13 ||
                    e.keyCode == 38 || e.keyCode == 27) {
                    return;
                }

                keyword = this.NormalizeKeyword(e.target.value);

                this.m_Text = keyword;
 

                this.lastKeyUpTime = new Date();


                if (e.keyCode == 37 || e.keyCode == 39) {//Press Left or Right , Just Return
                    return;
                }


                if (this.Strict == "false" || this.Strict == false) {
                    this.$emit("input", this.m_Text);
                }

                //for (i = 0; i < this.FinalOptions.length; i++) {
                //    if (this.FinalOptions[i].Value == keyword) {
                //        this.SelectedIndex = i;

                //        setTimeout(
                //            () => {
                //                this.SetSelectedOptionItemVisible();
                //            },
                //            50
                //        );

                //        break;
                //    }
                //}
                 
                if (!this.IsQuery) {
                    this.IsQuery = true;

                    setTimeout
                        (
                            function () {
                                this.Query();
                            }.bind(this)
                            ,
                            100
                        );
                }
            },

            UpdateElementByAttribute() {

            },

            NormalizeKeyword(keyword) {
                let normalizedKeyword = "";
                let keywordRegex = /\([^\)]+\)/g;

                if (keyword != null) {
                    
                    normalizedKeyword = (keyword+"").replace(keywordRegex, "");
                    normalizedKeyword = normalizedKeyword.replace(/^\s+/g, '');
                }

                return normalizedKeyword;
            },

            DelayQuery() {
                this.m_RequestQueryNo++;

                if (this.IsQuery) {
                    setTimeout(
                        this.DelayQuery,
                        1000
                    );
                }
                else {
                    if (this.m_RequestQueryNo != this.m_LastRequestQueryNo) {
                        this.IsQuery = true;
                        this.m_LastRequestQueryNo = this.m_RequestQueryNo;
                        this.Query();
                    }
                }
            },

            Query() {
                let last_Text;
                let listViewRequest = {
                    Query: {}
                };
                let queryObject = {};
                let i;

                //console.log(this.GetData)


                this.m_LastText = this.m_Text;

                //console.log("Query()")

                this.IsQuery = true;

                listViewRequest.Query.ValueSet = {};

                listViewRequest = this.CreateQueryRequestHandler.call(this.$parent,this.m_Text);


                queryObject = listViewRequest.Query;

                if (
                    listViewRequest == null &&
                    (this.GetData != undefined && this.GetData != null) &&
                    this.IsNewGetDataVersion == false
                )
                {
                    listViewRequest = {
                        Text: this.m_Text,
                        ValueData: this.GetData,
                        Query: queryObject
                    }
                }
                else {
                    if (this.GetDataIsList != undefined && this.GetDataIsList != null && this.GetDataIsList != false) {
                        listViewRequest = {
                            Text: this.m_Text,
                            GetDataList: this.GetData ,
                            Query : queryObject
                        }
                    }
                    else {
                        if (listViewRequest != null) {

                            if (listViewRequest.Text == null) {
                                listViewRequest.Text = this.m_Text;
                            }

                            listViewRequest.GetData = this.GetData;
                            listViewRequest.Query = queryObject;

                        }
                        else {
                            listViewRequest = {
                                Text: this.m_Text,
                                GetData: this.GetData,
                                Query: queryObject
                            }
                        }
                    }
                }

                if( listViewRequest.ValueData != undefined && listViewRequest.ValueData != null && listViewRequest.ValueData.ViewerPolicy != undefined && listViewRequest.ValueData.ViewerPolicy != null) {
                    listViewRequest.ValueData.ViewerPolicy = parseInt(listViewRequest.ValueData.ViewerPolicy, 10);
                }

                if (this.ShowAllOptions != "true") {
                    listViewRequest.Paging = { RecordPerPage: 30 };
                }
                else {
                    listViewRequest.Paging = { RecordPerPage: 10000 };
                }



                apiService.Post(this.apiUrl, listViewRequest).then(
                    function (responseData) {
                        let optionItem;
                        let option;
                        let responseRows;
                        let i;

 
                        this.lastQueryTime = new Date();

                        last_Text = this.NormalizeKeyword(this.m_Text);

                        this.FinalOptions.length = 0;

          
                        if (Array.isArray(responseData)) {
                            responseRows = responseData;
                        }
                        else {
                            responseRows = responseData.Rows;

                            if (responseRows == null) {
                                responseRows = [];
                            }
                        }

                        if (this.m_Text == "" &&
                            this.cacheResponseRows.length == 0 &&
                            responseRows.length > 0
                        )
                        {
                            this.cacheResponseRows = responseRows;
                        }

 
                        for (i = 0; i < responseRows.length; i++) {
                            optionItem = {};
                            optionItem.Selectable = true;

                            if (this.GetOptionSelectableHandler != null) {
                                if (!this.GetOptionSelectableHandler(responseRows[i])) {
                                    optionItem.Selectable = false;
                                }
                            }
                            optionItem.Text = this.CreateOptionTextHandler(responseRows[i]);
                            optionItem.Value = optionItem.Text;
                            optionItem.Row = responseRows[i];

                            this.FinalOptions.push(
                                optionItem
                            );
                        }

                        this.m_LastOptionCount = this.FinalOptions.length;
     
                        if (last_Text != this.NormalizeKeyword(this.m_Text))
                        {

                            if (this.IsQuery == false) {
                                this.IsQuery = true;

                                setTimeout(
                                    function () {
                                        this.Query();
                                        this.IsQuery = false;
                                    }.bind(this)
                                    ,
                                    1000
                                );
                            }
                        } else {
                            this.IsQuery = false;
                        }
                    }.bind(this)
                ).catch(
                    (error) => {
                        console.log("InputQuery:apiService.Post() fail:" + error);
                        alert(error);
                    }
                );


            }
            ,

            OnAppClick(event) {
                let insideControl = false;
                let parentElement;


                parentElement = event.target;

                while (parentElement.tagName != "BODY") {
                    if (parentElement.classList.contains("DropDownMenu") ||
                        parentElement.classList.contains("InputQuery")
                    ) {
                        insideControl = true;
                        break;
                    }

                    if (parentElement.parentElement == null) {
                        break;
                    }
                    parentElement = parentElement.parentElement;

                    if (parentElement == null) {
                        break;
                    }
                }

                if (!insideControl) {
                    this.FinalOptions = [];
                    this.$forceUpdate();
                }
            },

            OnAppEscape(event) {
                this.FinalOptions = [];
                this.$forceUpdate();
            },


            Clear() {
                this.m_Text = "";

                this.SelectedIndex = -1;
                this.FinalOptions = [];

                this.$forceUpdate();

                setTimeout(
                    () => {
                        this.m_Text = "";
                    },
                    60
                );
            },


        },



        beforeMounted() {

        },

        created() {
 
            if (this.value == null) {
                this.m_Text = "";
            }
            else {
                this.m_Text = this.value;
            }
 
            if (this.title != null) {
                this.m_title = this.title;
            }
 
            if (this.nullable != null) {
                this.m_Nullable = this.nullable;
            }

            if (this.QueryApiUrl != null) {
                this.apiUrl = this.QueryApiUrl;
            }

            if (this.PlaceHolder != null) {
                this.m_PlaceHolder = this.PlaceHolder;
            }

            if (this.CreateOptionTextHandler == null) {
                alert("InputQuery : props 'CreateOptionTextHandler' must be set !");
                return;
            }

            if (this.CreateQueryRequestHandler == null) {
                alert("InputQuery : props 'CreateQueryRequestHandler' must be set !");
                return;
            }

            if (this.$bus != null) {
                this.$bus.$on('AppClick',
                    function (event) {
                        this.OnAppClick(event);
                    }.bind(this)
                );

                this.$bus.$on('AppEscape',
                    function (event) {
                        this.OnAppEscape(event);
                    }.bind(this)
                );
            }

        },

        watch: {

            m_Text: function (newVal, oldVal) {
                this.m_Text = newVal;
            },

            value: function (newVal, oldVal) {
                let currDate = new Date();

                this.m_Text = newVal;

                
                this.$forceUpdate();

            },

            m_ValueData: function (newVal, oldVal) {
                this.m_ValueData = newVal
            },


            SelectedIndex: function (newVal, oldVal) {
            },

            text: function (newVal, oldVal) {
                this.m_Text = newVal;
            },

            nullable: function (newVal, oldVal) {

            },


            '$route'(to, from) {
                // react to route changes...
                this.lastKeyWord = "";
                this.m_LastOptionCount = 0;
                this.IsQuery = false;
            }
        }

    }


</script>

<style scoped>

    .InputQuery {
        
        position: relative;
        display: inline-block;
        width: 100%;
        text-align: left;
    }

        .InputQuery INPUT {
            border-color:rgba(125,125,125,0.5);
            border-radius:4px;
            padding:0.5em;
            height:3em;
            width: 100%
        }

        .InputQuery .LoadingBlock {
            position: absolute;
            display: block;
            left: 0%;
            top: 20px;
        }

        .InputQuery .DropDownMenu {
            position: absolute;
            display: block;
            left: 0%;
            top: 35px;
            min-height: 100px;
            max-height: 250px;
            min-width: 100%;
            max-width: 100%;
            overflow-x: hidden;
            background-color: #ffffff;
            border: 1px solid #c0c0c0;
            padding-left: 2px;
            padding-right: 2px;
            z-index: 20;
            -webkit-box-shadow: 0px 2px 7px 0px rgba(0,0,0,0.33);
            -moz-box-shadow: 0px 2px 7px 0px rgba(0,0,0,0.33);
            box-shadow: 0px 2px 7px 0px rgba(0,0,0,0.33);
            overflow-y: scroll;
        }

            .InputQuery .DropDownMenu .OptionItem {
                font-family: 微軟正黑體;
                font-size: 14px;
                padding-bottom: 2px;
                cursor: pointer;
                white-space: pre-wrap;
                width:auto;
                min-width: 250px;
                overflow: hidden;
            }


                .InputQuery .DropDownMenu .OptionItem:not(.Selected):hover {
                    background-color: #f5f5f0;
                }


                .InputQuery .DropDownMenu .OptionItem.Selected {
                    background-color: rgb(30,144,255);
                    color: white;
                }
</style>
